import React, { useState, useEffect } from "react";

import BeatLoader from "react-spinners/BeatLoader";
import Chip from '@material-ui/core/Chip';
import swal from 'sweetalert'
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Divider from '@material-ui/core/Divider';

import { halfSpace } from "@persian-tools/persian-tools";

import styles from "assets/jss/material-kit-react/views/learningPage.js";
import Axios from "axios";
import Config from "../../../../config"
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import CloseSharpIcon from '@material-ui/icons/CloseSharp';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import ScienceCommitteeDetailsTemplate from "../../../../components/ScienceCommitteeDetailsTemplate";
import {Helmet} from 'react-helmet'

import {
  useHistory
} from "react-router-dom";

import {
    useParams
  } from "react-router-dom";

const useStyles = makeStyles(styles);

export default function ScienceCommittee(props) {
    const [open, setOpen] = React.useState(false);
  let [loading, setLoading] = useState(true);
  const [scienceCommittees, setScienceCommittees] = useState(null);
  const [selected, setSelected] = useState(null);
  let { subId } = useParams();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    window.history.pushState('ScienceCommittee', selected?.name?selected?.name:"", './');

  };
  useEffect(()=>{
    const fetchData = async () => {
      setLoading(true)
      Axios.post(Config.api + "Product/GetTeachers",{
  
      },
        {
          headers: {
            apikey: Config.apikey,
            Authorization: (localStorage.getItem('token')) ? "Bearer " + localStorage.getItem('token') : ""
  
          }
        }).then(async (result) => {
          setLoading(false)
          setScienceCommittees(result.data.data)
              if(subId){
                  result.data.data.map(function (item){
                      if(item._id==subId||item.shortId==subId){
                          setSelected(item);
                          setOpen(true);
                      }
                  })
              }
          
        }).catch((err) => {
          setLoading(false)
  
          if (err && err.response && err.response.status && err.response.status === 401) {
            localStorage.removeItem('token');
            props.history.push("/SignIn");
          }
          else if (err && err.response && err.response.status && err.response.status === 422)
            swal("اطلاعات ارسالی نادرست است.");
          else if (err && err.response && err.response.status && err.response.status === 409) {
            swal("اطلاعات ارسالی نادرست است.");
          }
          else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
            swal(err.response.data.message.pr);
          else swal("خطایی رخ داده است. لطفا اتصال اینترنت را بررسی کنید.")
        })
    };
    fetchData();
  }, []);
  function Details(data) {
     setSelected(data);
     handleClickOpen(true)
    window.history.pushState('ScienceCommittee',data.name, './'+ data.shortId);

    //history.push("/Courses/ScienceCommittee/Details/" + id);
  }
  const classes = useStyles();
  
  const MyDialog  = (props) => {
    const { data, children, onClose, ...other } = props;
   
    return (
        <Dialog
        className={classes.right}
        fullScreen={false}
        maxWidth={'xl'}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
           <ScienceCommitteeDetailsTemplate data={data}></ScienceCommitteeDetailsTemplate>
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.left}>
          <Button onClick={handleClose} autoFocus>
            بستن <CloseSharpIcon />
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  
  return (
    <div className={classes.container}>
      <div className={classes.center + " " + classes.fastAccess}>
        <BeatLoader loading={loading} color={"gray"} size={15} />
      </div>
    <Helmet>
    <title>{"اعضای هیئت علمی | گروه sharifcamp"}</title>
    <meta name="description" content={"اساتید sharifcamp خبره و با تجربه اند. مباحث بر اساس جدیدترین اطلاعات هر دوره ارائه خواهند شد."} />
    <meta name="keywords" content={["Teachers","Lecture","sharifcamp","مدرسین","مدرس","هیئت علمی"]} />
  </Helmet>
      <GridContainer justify="left" className={classes.box}>
        {scienceCommittees && scienceCommittees.map((scienceCommittee, index) => {
          return (
            <GridItem xs={12} sm={6} md={3}>
              <Card variant="outlined" className={classes.card + " " + classes.right}>
                <CardActionArea onClick={() => Details(scienceCommittee)}>
                  <CardMedia
                    component="img"
                    alt={halfSpace(scienceCommittee.name)}
                    height="200"
                    image={scienceCommittee.picture}
                    title={halfSpace(scienceCommittee.title)}
                  />
                  <CardContent className={classes.cardContent}>
                  <div>
                      <Typography gutterBottom variant="button" >
                        {scienceCommittee.name && scienceCommittee.name.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                      </Typography>
                    </div>
                    <div  className={classes.sameSize}>
                    <Typography className={classes.justify + " " + classes.right} variant="caption" color="textSecondary" >
                      {scienceCommittee.title && halfSpace(scienceCommittee.title).split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                    </Typography>
                    </div>
                  </CardContent>
                  <Divider />
                </CardActionArea>
                <CardActions>

                  <div className={classes.left + " " + classes.cardBtn}>
                    <Button onClick={() => Details(scienceCommittee)} size="small" color="primary">
                      اطلاعات بیشتر
                    </Button>
                  </div>
                </CardActions>
              </Card>
            </GridItem>
          )
        })}
      </GridContainer>
      <div className={classes.description}>
        <p>
          {" "}
        </p>
      </div>
      <div>
      <MyDialog data={selected}></MyDialog>
      </div>
    </div>
  );
}





